<ng-container
    *ngrxLet="{
        isInitialDialogOpen: isInitialDialogOpen$,
        isCredentialsDialogOpen: isCredentialsDialogOpen$,
        isFeedDialogOpen: isFeedDialogOpen$,
        isLoading: isLoading$,
        inEditMode: inEditMode$,
        isApiKeyDisabled: isApiKeyDisabled$,
        isSaveButtonDisabled: isSaveButtonDisabled$,
        isFeedSaveButtonDisabled: isFeedSaveButtonDisabled$,
        isAccessTokenEnabled: isAccessTokenEnabled$,
        isSelectProductsEnabled: isSelectProductsEnabled$,
        isSelectLinksEnabled: isSelectLinksEnabled$,
        isProductsStepVisible: isProductsStepVisible$,
        isLinksStepVisible: isLinksStepVisible$,
    } as settings">
    <div class="st-discover-admin-settings-dialog-container">
        @if (settings.isLoading | ngrxPush) {
            <st-loader
                class="st-discover-admin-settings-dialog-loader"
                [diameter]="200"
                [strokeWidth]="10" />
        }
        @if (settings.isInitialDialogOpen) {
            <div class="st-discover-admin-settings-dialog-container__header">
                <span
                    class="st-discover-admin-settings-dialog-container__header--title"
                    [title]="languageSettings.PSTWebDiscoverAdminSettingsLabel">
                    {{ languageSettings.PSTWebDiscoverAdminSettingsLabel }}
                </span>
                <button
                    class="st-discover-admin-settings-dialog-container__header--btnClose"
                    mat-icon-button
                    mat-dialog-close>
                    <mat-icon>close</mat-icon>
                </button>
            </div>

            <mat-tab-group [selectedIndex]="selectedTabIndex$ | ngrxPush">
                <mat-tab [label]="languageSettings.PSTWebDiscoverCredentialsLabel">
                    <div class="st-discover-admin-settings-dialog-container-tab">
                        <div class="st-discover-admin-settings-dialog-container-tab__btns">
                            <button
                                class="st-discover-admin-settings-dialog-container-tab__btns--add"
                                mat-button
                                (click)="addCredentials()">
                                <mat-icon [attr.small]="true">add</mat-icon>
                                {{ languageSettings.PSTWebDiscoverAddButton }}
                            </button>
                        </div>
                    </div>
                    <mat-list class="st-discover-admin-settings-dialog-container-tab__list">
                        @for (cred of credentials$ | ngrxPush; track cred?.wireCredentialsId) {
                            <mat-list-item class="st-discover-admin-settings-dialog-container-tab__list-item">
                                <div class="st-discover-admin-settings-dialog-container-tab__list-item-container">
                                    <div class="st-discover-admin-settings-dialog-container-tab__list-item-container--info">
                                        {{ cred.name }}
                                    </div>
                                    <div class="st-discover-admin-settings-dialog-container-tab__list-item-container--actions">
                                        <button
                                            mat-icon-button
                                            medium
                                            class="st-discover-admin-settings-dialog-container-tab__list--item--btnEdit"
                                            (click)="editCredentials(cred)">
                                            <mat-icon>edit_outline</mat-icon>
                                        </button>
                                        <button
                                            mat-icon-button
                                            medium
                                            class="st-discover-admin-settings-dialog-container-tab__list-item--btnRemove"
                                            (click)="removeCredentials(cred)">
                                            <mat-icon>delete_outline</mat-icon>
                                        </button>
                                    </div>
                                </div>
                            </mat-list-item>
                        }
                    </mat-list>
                </mat-tab>
                <mat-tab [label]="languageSettings.PSTWebDiscoverFeedsLabel">
                    <div class="st-discover-admin-settings-dialog-container-tab">
                        <div class="st-discover-admin-settings-dialog-container-tab__btns">
                            <button
                                class="st-discover-admin-settings-dialog-container-tab__btns--add"
                                mat-button
                                (click)="openAddFeedDialog()">
                                <mat-icon [attr.small]="true">add</mat-icon>
                                {{ languageSettings.PSTWebDiscoverAddButton }}
                            </button>
                        </div>
                    </div>

                    <mat-list class="st-discover-admin-settings-dialog-container-tab__list">
                        @for (feed of feeds$ | ngrxPush; track feed?.id) {
                            <mat-list-item class="st-discover-admin-settings-dialog-container-tab__list-item">
                                <div class="st-discover-admin-settings-dialog-container-tab__list-item-container">
                                    <div class="st-discover-admin-settings-dialog-container-tab__list-item-container--info">
                                        {{ feed.name }}
                                    </div>
                                    <div class="st-discover-admin-settings-dialog-container-tab__list-item-container--actions">
                                        <button
                                            mat-icon-button
                                            medium
                                            class="st-discover-admin-settings-dialog-container-tab__list--item--btnEdit"
                                            (click)="editFeed(feed)">
                                            <mat-icon>edit_outline</mat-icon>
                                        </button>
                                        <button
                                            mat-icon-button
                                            medium
                                            class="st-discover-admin-settings-dialog-container-tab__list-item--btnRemove"
                                            (click)="removeFeed(feed)">
                                            <mat-icon>delete_outline</mat-icon>
                                        </button>
                                    </div>
                                </div>
                            </mat-list-item>
                        }
                    </mat-list>
                </mat-tab>
            </mat-tab-group>
        }
        @if (settings.isCredentialsDialogOpen) {
            <div class="st-discover-admin-settings-dialog-container__header">
                <span
                    class="st-discover-admin-settings-dialog-container__header--title"
                    [title]="languageSettings.PSTWebDiscoverNewAccessTokenLabel">
                    {{ settings.inEditMode ? languageSettings.PSTWebDiscoverEditAccessTokenLabel : languageSettings.PSTWebDiscoverNewAccessTokenLabel }}
                </span>
            </div>
            <div class="st-discover-admin-settings-dialog-container__head">
                <st-text-area-overlay
                    class="st-discover-admin-settings-dialog-container__title"
                    minHeight="2rem"
                    panelClass="st-discover-admin-settings-dialog-container__title"
                    [placeholder]="languageSettings.PSTWebDiscoverAddTokenNameLabel"
                    [value]="credentialsTitle$ | ngrxPush"
                    [required]="true"
                    (changed)="updateCredentialsTitle($event)" />
            </div>
            <div class="st-discover-admin-settings-dialog-container__body">
                <span class="st-discover-admin-settings-dialog-container__body-label">Type</span>
                <mat-radio-group
                    class="st-discover-admin-settings-dialog-container__body-radio-group"
                    [ngModel]="credentialsType()"
                    [disabled]="settings.inEditMode">
                    <mat-radio-button
                        [value]="wireFeedTypes.AP"
                        (change)="updateCredentialsType(wireFeedTypes.AP)">
                        {{ languageSettings.PSTWebDiscoverAssociatedPressKeyLabel }}
                    </mat-radio-button>
                    <mat-radio-button
                        [value]="wireFeedTypes.TWITTER"
                        (change)="updateCredentialsType(wireFeedTypes.TWITTER)">
                        {{ languageSettings.PSTWebDiscoverXKeyLabel }}
                    </mat-radio-button>
                    <mat-radio-button
                        [value]="wireFeedTypes.DATAMINR"
                        (change)="updateCredentialsType(wireFeedTypes.DATAMINR)">
                        {{ languageSettings.PSTWebDiscoverDataminrKeyLabel }}
                    </mat-radio-button>
                </mat-radio-group>

                @if (credentialsType() === wireFeedTypes.AP || credentialsType() === wireFeedTypes.TWITTER) {
                    <st-text-field
                        class="st-discover-admin-settings-dialog-container__body-stepper__apiCredentialsField"
                        [placeholder]="languageSettings.PSTWebDiscoverAPIKeyLabel"
                        [label]="languageSettings.PSTWebDiscoverAPIKeyLabel"
                        [value]="apiKey$ | ngrxPush"
                        [disabled]="settings.isApiKeyDisabled"
                        (changed)="updateApiKey($event)" />
                }
                @if (credentialsType() === wireFeedTypes.DATAMINR) {
                    <st-text-field
                        class="st-discover-admin-settings-dialog-container__body-stepper__apiCredentialsField"
                        [placeholder]="languageSettings.PSTWebDiscoverDataminrClientIdLabel"
                        [label]="languageSettings.PSTWebDiscoverDataminrClientIdLabel"
                        [value]="dataminrClientId$ | ngrxPush"
                        [disabled]="settings.isApiKeyDisabled"
                        (changed)="updateDataminrClientId($event)" />
                    <st-text-field
                        class="st-discover-admin-settings-dialog-container__body-stepper__apiCredentialsField"
                        [placeholder]="languageSettings.PSTWebDiscoverDataminrClientSecretLabel"
                        [label]="languageSettings.PSTWebDiscoverDataminrClientSecretLabel"
                        [value]="dataminrClientSecret$ | ngrxPush"
                        [disabled]="settings.isApiKeyDisabled"
                        (changed)="updateDataminrClientSecret($event)" />
                }
            </div>
            <mat-divider />
            <div class="st-discover-admin-settings-dialog-container__footer">
                <button
                    mat-button
                    (click)="cancel()">
                    {{ languageSettings.PSTWebCancelButtonLabel }}
                </button>
                <button
                    mat-button
                    color="primary"
                    [disabled]="settings.isSaveButtonDisabled | ngrxPush"
                    (click)="saveCredentials()">
                    @if (!settings.isLoading) {
                        {{ settings.inEditMode ? languageSettings.PSTWebDiscoverEditButton : languageSettings.PSTWebDiscoverCreateButton }}
                    } @else {
                        <st-loader
                            class="st-discover-admin-settings-dialog-panel-create-footer-buttons__spinner"
                            [diameter]="30"
                            [strokeWidth]="5" />
                    }
                </button>
            </div>
        }
        @if (settings.isFeedDialogOpen) {
            <div class="st-discover-admin-settings-dialog-container__header">
                <span
                    class="st-discover-admin-settings-dialog-container__header--title"
                    [title]="languageSettings.PSTWebDiscoverAdminSettingsLabel">
                    {{ settings.inEditMode ? languageSettings.PSTWebDiscoverEditFeedLabel : languageSettings.PSTWebDiscoverNewFeedLabel }}
                </span>
            </div>
            @if (!settings.inEditMode) {
                <div class="st-discover-admin-settings-dialog-container__head">
                    <st-text-area-overlay
                        class="st-discover-admin-settings-dialog-container__title"
                        minHeight="2rem"
                        panelClass="st-discover-admin-settings-dialog-container__title"
                        [placeholder]="languageSettings.PSTWebDiscoverAddFeedNameLabel"
                        [value]="feedTitle$ | ngrxPush"
                        [required]="true"
                        (changed)="updateFeedTitle($event)" />
                </div>
                <div class="st-discover-admin-settings-dialog-container__body">
                    <mat-stepper
                        #stepper
                        class="st-discover-admin-settings-dialog-container__body-stepper"
                        orientation="vertical"
                        [linear]="false">
                        <mat-step [completed]="settings.isAccessTokenEnabled">
                            <ng-template matStepLabel>{{ languageSettings.PSTWebDiscoverChooseFeedSourceLabel }}</ng-template>
                            <ng-template matStepContent>
                                <mat-radio-group class="st-discover-admin-settings-dialog-container__body-radio-group">
                                    <mat-radio-button
                                        [value]="wireFeedTypes.AP"
                                        (change)="updateFeedType(wireFeedTypes.AP)">
                                        {{ languageSettings.PSTWebDiscoverAssociatedPressLabel }}
                                    </mat-radio-button>
                                    <mat-radio-button
                                        [value]="wireFeedTypes.FTP"
                                        (change)="updateFeedType(wireFeedTypes.FTP)">
                                        {{ languageSettings.PSTWebDiscoverFTPServerLabel }}
                                    </mat-radio-button>
                                    <mat-radio-button
                                        [value]="wireFeedTypes.SFTP"
                                        (change)="updateFeedType(wireFeedTypes.SFTP)">
                                        {{ languageSettings.PSTWebDiscoverSFTPServerLabel }}
                                    </mat-radio-button>
                                    <mat-radio-button
                                        [value]="wireFeedTypes.DATAMINR"
                                        (change)="updateFeedType(wireFeedTypes.DATAMINR)">
                                        {{ languageSettings.PSTWebDiscoverDataminrLabel }}
                                    </mat-radio-button>
                                </mat-radio-group>
                                <button
                                    mat-button
                                    color="primary"
                                    class="st-discover-admin-settings-dialog-container__body-stepper--btnNext"
                                    [disabled]="!settings.isAccessTokenEnabled"
                                    (click)="onSelectAccessTokenClicked(stepper)">
                                    {{ languageSettings.PSTWebNextLabel }}
                                </button>
                            </ng-template>
                        </mat-step>
                        <mat-step [completed]="settings.isSelectProductsEnabled">
                            <ng-template matStepLabel>{{ languageSettings.PSTWebDiscoverSelectAccessTokenLabel }}</ng-template>
                            <ng-template matStepContent>
                                <ng-container *ngrxLet="feedType$ as feedType">
                                    @if (feedType === wireFeedTypes.FTP || feedType === wireFeedTypes.SFTP) {
                                        <form
                                            class="st-discover-admin-settings-dialog-container__body-stepper__ftpForm"
                                            [formGroup]="ftpForm">
                                            <mat-form-field class="st-discover-admin-settings-dialog__body-stepper__ftpForm--provider">
                                                <mat-label>Provider</mat-label>
                                                <mat-select
                                                    formControlName="provider"
                                                    required
                                                    (selectionChange)="updateFtpProvider($event.value)">
                                                    @for (provider of ftpProviders$ | ngrxPush; track provider.providerId) {
                                                        <mat-option [value]="provider.providerId">
                                                            <span>{{ provider.name }}</span>
                                                        </mat-option>
                                                    }
                                                </mat-select>
                                            </mat-form-field>

                                            <mat-form-field class="st-discover-admin-settings-dialog__body-stepper__ftpForm--urlKey">
                                                <mat-hint>{{ ftpOrSftpHint | ngrxPush }}</mat-hint>
                                                <mat-label>{{ languageSettings.PSTWebDiscoverURLLabel }}</mat-label>
                                                <input
                                                    formControlName="url"
                                                    matInput
                                                    required
                                                    [placeholder]="languageSettings.PSTWebDiscoverEnterURLLabel"
                                                    (change)="updateFtpUrl($event)" />
                                            </mat-form-field>
                                            <mat-form-field class="st-discover-admin-settings-dialog__body-stepper__ftpForm--username">
                                                <mat-label>{{ languageSettings.PSTWebDiscoverUsernameLabel }}</mat-label>
                                                <input
                                                    formControlName="username"
                                                    matInput
                                                    [placeholder]="languageSettings.PSTWebDiscoverEnterUsernameLabel"
                                                    (change)="updateFtpUsername($event)" />
                                            </mat-form-field>

                                            <mat-form-field class="st-discover-admin-settings-dialog__body-stepper__ftpForm--password">
                                                <mat-label>{{ languageSettings.PSTWebDiscoverPasswordLabel }}</mat-label>
                                                <input
                                                    formControlName="password"
                                                    matInput
                                                    type="password"
                                                    [placeholder]="languageSettings.PSTWebDiscoverEnterPasswordLabel"
                                                    (change)="updateFtpPassword($event)" />
                                            </mat-form-field>
                                            <mat-form-field class="st-discover-admin-settings-dialog__body-stepper__ftpForm--directory">
                                                <mat-label>{{ languageSettings.PSTWebDiscoverDirectoryLabel }}</mat-label>
                                                <input
                                                    formControlName="directory"
                                                    matInput
                                                    [placeholder]="languageSettings.PSTWebDiscoverEnterDirectoryLabel"
                                                    (change)="updateFtpDirectory($event)" />
                                            </mat-form-field>
                                        </form>
                                    }
                                    @if (feedType === wireFeedTypes.AP) {
                                        <mat-selection-list
                                            class="st-discover-admin-settings-dialog-container-tab__list"
                                            [multiple]="false"
                                            (selectionChange)="onCredentialsSelected($event, wireFeedTypes.AP)">
                                            @for (cred of apCredentials$ | ngrxPush; track cred) {
                                                <mat-list-option
                                                    class="st-discover-admin-settings-dialog-container-tab__list-item"
                                                    [value]="cred.wireCredentialsId">
                                                    <div class="st-discover-admin-settings-dialog-container-tab__list-item-container">
                                                        <div class="st-discover-admin-settings-dialog-container-tab__list-item-container--info">
                                                            {{ cred.name }}
                                                        </div>
                                                    </div>
                                                </mat-list-option>
                                            }
                                        </mat-selection-list>

                                        <button
                                            mat-button
                                            color="primary"
                                            class="st-discover-admin-settings-dialog-container__body-stepper--btnNext"
                                            [disabled]="!settings.isSelectProductsEnabled"
                                            (click)="onSelectProductsClicked(stepper)">
                                            {{ languageSettings.PSTWebNextLabel }}
                                        </button>
                                    }
                                    @if (feedType === wireFeedTypes.DATAMINR) {
                                        <mat-selection-list
                                            class="st-discover-admin-settings-dialog-container-tab__list"
                                            [multiple]="false"
                                            (selectionChange)="onCredentialsSelected($event, wireFeedTypes.DATAMINR)">
                                            @for (cred of dataminrCredentials$ | ngrxPush; track cred) {
                                                <mat-list-option
                                                    class="st-discover-admin-settings-dialog-container-tab__list-item"
                                                    [value]="cred.wireCredentialsId">
                                                    <div class="st-discover-admin-settings-dialog-container-tab__list-item-container">
                                                        <div class="st-discover-admin-settings-dialog-container-tab__list-item-container--info">
                                                            {{ cred.name }}
                                                        </div>
                                                    </div>
                                                </mat-list-option>
                                            }
                                        </mat-selection-list>

                                        <button
                                            mat-button
                                            color="primary"
                                            class="st-discover-admin-settings-dialog-container__body-stepper--btnNext"
                                            [disabled]="!settings.isSelectLinksEnabled"
                                            (click)="onSelectLinksClicked(stepper)">
                                            {{ languageSettings.PSTWebNextLabel }}
                                        </button>
                                    }
                                </ng-container>
                            </ng-template>
                        </mat-step>
                        @if (settings.isLinksStepVisible) {
                            <mat-step [completed]="settings.isSelectLinksEnabled">
                                <ng-template matStepLabel>{{ languageSettings.PSTWebDiscoverSelectLinksLabel }}</ng-template>
                                <div>
                                    <mat-form-field
                                        #trigger="cdkOverlayOrigin"
                                        subscriptSizing="dynamic"
                                        class="st-discover-admin-settings-dialog-selectProductSection-stepper__productSearchField"
                                        cdkOverlayOrigin>
                                        <input
                                            #search
                                            matInput
                                            class="st-discover-admin-settings-dialog-selectProductSection-stepper__productSearchField--input"
                                            [placeholder]="languageSettings.PSTWebDiscoverBALLabel"
                                            [formControl]="searchLink"
                                            (input)="filterLinks(search.value)" />
                                        <button
                                            mat-icon-button
                                            matPrefix
                                            class="st-discover-admin-settings-dialog-selectProductSection-stepper__productSearchField--btnSearch">
                                            <mat-icon class="material-symbols-outlined">search</mat-icon>
                                        </button>
                                        @if (searchLink.value) {
                                            <button
                                                mat-icon-button
                                                matSuffix
                                                class="st-discover-admin-settings-dialog-selectProductSection-stepper__productSearchField--btnClose"
                                                (click)="filterLinks('')">
                                                <mat-icon class="material-symbols-outlined">close</mat-icon>
                                            </button>
                                        }
                                    </mat-form-field>
                                    @if (isNotLoading$ | ngrxPush) {
                                        <mat-checkbox (change)="onSelectAll($event.checked, linksList, wireFeedTypes.DATAMINR)">
                                            {{ languageSettings.PSTWebSelectAllLabel }}
                                        </mat-checkbox>
                                    }
                                    <mat-selection-list
                                        #linksList
                                        class="st-discover-admin-settings-dialog-container-tab__list"
                                        [ngModel]="dataminrSelectedLinks()"
                                        (selectionChange)="onSelectedLinksChange($event)">
                                        @for (link of dataminrLinks(); track linkById($index, link)) {
                                            <mat-list-option [value]="link.id">
                                                {{ link.name }}
                                            </mat-list-option>
                                        }
                                    </mat-selection-list>
                                </div>
                            </mat-step>
                        }

                        @if (settings.isProductsStepVisible) {
                            <mat-step [completed]="false">
                                <ng-template matStepLabel>{{ languageSettings.PSTWebDiscoverSelectProductsLabel }}</ng-template>
                                <ng-template matStepContent>
                                    <mat-form-field
                                        #trigger="cdkOverlayOrigin"
                                        subscriptSizing="dynamic"
                                        class="st-discover-admin-settings-dialog-selectProductSection-stepper__productSearchField"
                                        cdkOverlayOrigin>
                                        <input
                                            #search
                                            matInput
                                            class="st-discover-admin-settings-dialog-selectProductSection-stepper__productSearchField--input"
                                            [placeholder]="languageSettings.PSTWebDiscoverBAPLabel"
                                            [formControl]="searchProduct"
                                            (input)="filterProducts(search.value)" />
                                        <button
                                            mat-icon-button
                                            matPrefix
                                            class="st-discover-admin-settings-dialog-selectProductSection-stepper__productSearchField--btnSearch">
                                            <mat-icon class="material-symbols-outlined">search</mat-icon>
                                        </button>
                                        @if (searchProduct.value) {
                                            <button
                                                mat-icon-button
                                                matSuffix
                                                class="st-discover-admin-settings-dialog-selectProductSection-stepper__productSearchField--btnClose"
                                                (click)="filterProducts('')">
                                                <mat-icon class="material-symbols-outlined">close</mat-icon>
                                            </button>
                                        }
                                    </mat-form-field>
                                    @if (isNotLoading$ | ngrxPush) {
                                        <mat-checkbox (change)="onSelectAll($event.checked, productsList, wireFeedTypes.AP)">
                                            {{ languageSettings.PSTWebSelectAllLabel }}
                                        </mat-checkbox>
                                    }
                                    <mat-selection-list
                                        #productsList
                                        class="st-discover-admin-settings-dialog-container-tab__list"
                                        [ngModel]="apSelectedProducts()"
                                        (selectionChange)="onSelectedProductsChange($event)">
                                        @for (product of apProducts(); track productById($index, product)) {
                                            <mat-list-option [value]="product.id">
                                                {{ product.name }}
                                            </mat-list-option>
                                        }
                                    </mat-selection-list>
                                </ng-template>
                            </mat-step>
                        }
                    </mat-stepper>
                </div>
            }
            @if (settings.inEditMode) {
                <div class="st-discover-admin-settings-dialog-container__head">
                    <st-text-area-overlay
                        class="st-discover-admin-settings-dialog-container__title"
                        minHeight="2rem"
                        panelClass="st-discover-admin-settings-dialog-container__title"
                        [placeholder]="languageSettings.PSTWebDiscoverAddFeedNameLabel"
                        [value]="feedTitle$ | ngrxPush"
                        [required]="true"
                        (changed)="updateFeedTitle($event)" />
                </div>
                @if ((feedType$ | ngrxPush) === wireFeedTypes.AP) {
                    <div class="st-discover-admin-settings-dialog-container__body">
                        <mat-form-field
                            #trigger="cdkOverlayOrigin"
                            subscriptSizing="dynamic"
                            class="st-discover-admin-settings-dialog-selectProductSection-stepper__productSearchField"
                            cdkOverlayOrigin>
                            <input
                                #search
                                matInput
                                class="st-discover-admin-settings-dialog-selectProductSection-stepper__productSearchField--input"
                                [placeholder]="languageSettings.PSTWebDiscoverBAPLabel"
                                [formControl]="searchProduct"
                                (input)="filterProducts(search.value)" />
                            <button
                                mat-icon-button
                                matPrefix
                                class="st-discover-admin-settings-dialog-selectProductSection-stepper__productSearchField--btnSearch">
                                <mat-icon class="material-symbols-outlined">search</mat-icon>
                            </button>
                            @if (searchProduct.value) {
                                <button
                                    mat-icon-button
                                    matSuffix
                                    class="st-discover-admin-settings-dialog-selectProductSection-stepper__productSearchField--btnClose"
                                    (click)="filterProducts('')">
                                    <mat-icon class="material-symbols-outlined">close</mat-icon>
                                </button>
                            }
                        </mat-form-field>
                        @if (isNotLoading$ | ngrxPush) {
                            <mat-checkbox (change)="onSelectAll($event.checked, productsList, wireFeedTypes.AP)">{{ languageSettings.PSTWebSelectAllLabel }}</mat-checkbox>
                        }
                        <mat-selection-list
                            #productsList
                            class="st-discover-admin-settings-dialog-container-tab__list"
                            [ngModel]="apSelectedProducts()"
                            (selectionChange)="onSelectedProductsChange($event)">
                            @for (product of apProducts(); track productById($index, product)) {
                                <mat-list-option [value]="product.id">{{ product.name }}</mat-list-option>
                            }
                        </mat-selection-list>
                    </div>
                }
                @if ((feedType$ | ngrxPush) === wireFeedTypes.DATAMINR) {
                    <div class="st-discover-admin-settings-dialog-container__body">
                        <mat-form-field
                            #trigger="cdkOverlayOrigin"
                            subscriptSizing="dynamic"
                            class="st-discover-admin-settings-dialog-selectProductSection-stepper__productSearchField"
                            cdkOverlayOrigin>
                            <input
                                #search
                                matInput
                                class="st-discover-admin-settings-dialog-selectProductSection-stepper__productSearchField--input"
                                [placeholder]="languageSettings.PSTWebDiscoverBALLabel"
                                [formControl]="searchLink"
                                (input)="filterLinks(search.value)" />
                            <button
                                mat-icon-button
                                matPrefix
                                class="st-discover-admin-settings-dialog-selectProductSection-stepper__productSearchField--btnSearch">
                                <mat-icon class="material-symbols-outlined">search</mat-icon>
                            </button>
                            @if (searchLink.value) {
                                <button
                                    mat-icon-button
                                    matSuffix
                                    class="st-discover-admin-settings-dialog-selectProductSection-stepper__productSearchField--btnClose"
                                    (click)="filterLinks('')">
                                    <mat-icon class="material-symbols-outlined">close</mat-icon>
                                </button>
                            }
                        </mat-form-field>
                        @if (isNotLoading$ | ngrxPush) {
                            <mat-checkbox (change)="onSelectAll($event.checked, linksList, wireFeedTypes.DATAMINR)">
                                {{ languageSettings.PSTWebSelectAllLabel }}
                            </mat-checkbox>
                        }
                        <mat-selection-list
                            #linksList
                            class="st-discover-admin-settings-dialog-container-tab__list"
                            [ngModel]="dataminrSelectedLinks()"
                            (selectionChange)="onSelectedLinksChange($event)">
                            @for (link of dataminrLinks(); track link) {
                                <mat-list-option [value]="link.id">
                                    {{ link.name }}
                                </mat-list-option>
                            }
                        </mat-selection-list>
                    </div>
                }
                @if ((feedType$ | ngrxPush) === wireFeedTypes.FTP || (feedType$ | ngrxPush) === wireFeedTypes.SFTP) {
                    <div class="st-discover-admin-settings-dialog-container__body">
                        <form
                            class="st-discover-admin-settings-dialog-container__body-stepper__ftpForm"
                            autocomplete="off"
                            [formGroup]="ftpForm">
                            <mat-form-field class="st-discover-admin-settings-dialog__body-stepper__ftpForm--provider">
                                <mat-label>Provider</mat-label>
                                <mat-select
                                    formControlName="provider"
                                    required
                                    [ngModel]="ftpProvider$ | ngrxPush"
                                    (selectionChange)="updateFtpProvider($event.value)">
                                    @for (provider of ftpProviders$ | ngrxPush; track provider.providerId) {
                                        <mat-option [value]="provider.providerId">
                                            <span>{{ provider.name }}</span>
                                        </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field class="st-discover-admin-settings-dialog__body-stepper__ftpForm--urlKey">
                                <mat-hint>{{ ftpOrSftpHint | ngrxPush }}</mat-hint>
                                <mat-label>{{ languageSettings.PSTWebDiscoverURLLabel }}</mat-label>
                                <input
                                    formControlName="url"
                                    matInput
                                    required
                                    [placeholder]="languageSettings.PSTWebDiscoverEnterURLLabel"
                                    [ngModel]="ftpUrl$ | ngrxPush"
                                    (change)="updateFtpUrl($event)" />
                            </mat-form-field>
                            <mat-form-field class="st-discover-admin-settings-dialog__body-stepper__ftpForm--username">
                                <mat-label>{{ languageSettings.PSTWebDiscoverUsernameLabel }}</mat-label>
                                <input
                                    formControlName="username"
                                    matInput
                                    autocomplete="off"
                                    [placeholder]="languageSettings.PSTWebDiscoverEnterUsernameLabel"
                                    [ngModel]="ftpUsername$ | ngrxPush"
                                    (change)="updateFtpUsername($event)" />
                            </mat-form-field>

                            <mat-form-field class="st-discover-admin-settings-dialog__body-stepper__ftpForm--password">
                                <mat-label>{{ languageSettings.PSTWebDiscoverPasswordLabel }}</mat-label>
                                <input
                                    formControlName="password"
                                    matInput
                                    type="password"
                                    autocomplete="new-password"
                                    [ngModel]="ftpPassword$ | ngrxPush"
                                    [placeholder]="languageSettings.PSTWebDiscoverEnterPasswordLabel"
                                    (change)="updateFtpPassword($event)" />
                            </mat-form-field>
                            <mat-form-field class="st-discover-admin-settings-dialog__body-stepper__ftpForm--directory">
                                <mat-label>{{ languageSettings.PSTWebDiscoverDirectoryLabel }}</mat-label>
                                <input
                                    formControlName="directory"
                                    matInput
                                    [ngModel]="ftpDirectory$ | ngrxPush"
                                    [placeholder]="languageSettings.PSTWebDiscoverEnterDirectoryLabel"
                                    (change)="updateFtpDirectory($event)" />
                            </mat-form-field>
                        </form>
                    </div>
                }
            }
            <mat-divider />
            <div class="st-discover-admin-settings-dialog-container__footer">
                <button
                    mat-button
                    (click)="cancel()">
                    {{ languageSettings.PSTWebCancelButtonLabel }}
                </button>
                <button
                    mat-button
                    color="primary"
                    [disabled]="settings.isFeedSaveButtonDisabled | ngrxPush"
                    (click)="saveFeed()">
                    @if (!settings.isLoading) {
                        {{ settings.inEditMode ? languageSettings.PSTWebDiscoverEditButton : languageSettings.PSTWebDiscoverCreateButton }}
                    } @else {
                        <st-loader
                            class="st-discover-admin-settings-dialog-panel-create-footer-buttons__spinner"
                            [diameter]="30"
                            [strokeWidth]="5" />
                    }
                </button>
            </div>
        }
    </div>
</ng-container>
